import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from '../../context/ApiContext';
import { DashboardContext } from '../../context/DashboardContext';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, Legend, Category, Tooltip, BarSeries, DataLabel, Highlight } from '@syncfusion/ej2-react-charts';
import { FaStar, FaRegStar } from "react-icons/fa";
import { InputLabel, MenuItem, FormControl, Select, Skeleton } from '@mui/material'
import chroma from 'chroma-js';

export default function DemandasXCapacidades({ corFavorito, swotKey, tab }) {
    const theme = localStorage.getItem('theme') || 'light'
    const { qtdDemandaXCapacidade, setQtdDemandaXCapacidade, swotTipoDemandaXCapacidade, setSwotTipoDemandaXCapacidade, DemandaXCapacidade, getDemandaXCapacidade, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)

    const axisLabelRender = (args) => {
        theme == 'light' ? args.labelStyle.color = '#fff' : args.labelStyle.color = '#3f3f46'
    };

    const primaryxAxis = {
        titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
        labelIntersectAction: 'wrap',
        labelStyle: {
            textAlignment: 'center'
        },
        valueType: 'Category',
        interval: 1,
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 }
    };
    const primaryyAxis = {
        titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
        interval: 1,
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
        majorGridLines: { width: 0 }
    }

    useEffect(() => {
        if (swotKey != "") {
            setIsLoading(true)
            getDemandaXCapacidade(swotKey, qtdDemandaXCapacidade, swotTipoDemandaXCapacidade)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [swotKey, qtdDemandaXCapacidade, swotTipoDemandaXCapacidade])

    const onPointRender = (args) => {
        const baseColor = '#f37736';

        const colorPalette = chroma.scale([chroma(baseColor).darken(1), baseColor, chroma(baseColor).brighten(1)])
            .mode('lab')
            .colors(args.series.dataSource.length);

        args.fill = colorPalette[args.point.index];
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("Demandas x Capacidades de negócios")} className='btn-grafico'>{corFavorito("Demandas x Capacidades de negócios") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>Capacidades de Negócios x Demandas</span>
                </h2>
                <div style={{ display: 'flex' }}>
                    <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                        <InputLabel id="qtd-demanda">Quantidade de capacidades</InputLabel>
                        <Select
                            className='span-bsc'
                            labelId="qtd-demanda-label"
                            id="qtd-demanda"
                            value={qtdDemandaXCapacidade}
                            label="Quantidade de capacidades"
                            onChange={(e) => setQtdDemandaXCapacidade(parseInt(e.target.value))}
                        >
                            <MenuItem value="5">5</MenuItem>
                            <MenuItem value="10">10</MenuItem>
                            <MenuItem value="15">15</MenuItem>
                            <MenuItem value="20">20</MenuItem>
                            <MenuItem value="30">30</MenuItem>
                            <MenuItem value="40">40</MenuItem>
                            <MenuItem value="1000">Todas</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                        <InputLabel id="swot-sistema">SWOT</InputLabel>
                        <Select
                            className='span-bsc'
                            labelId="swot-label"
                            id="swot-sistema"
                            value={swotTipoDemandaXCapacidade}
                            label="SWOT"
                            onChange={(e) => setSwotTipoDemandaXCapacidade(e.target.value)}
                        >
                            <MenuItem value="Selecione">Selecione</MenuItem>
                            <MenuItem value="Forca">Força</MenuItem>
                            <MenuItem value="Fraqueza">Fraqueza</MenuItem>
                            <MenuItem value="Oportunidade">Oportunidade</MenuItem>
                            <MenuItem value="Ameaca">Ameaça</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="modal-content">
                <div style={{ width: '100%', minHeight: '400px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {isLoading ?
                        <Skeleton variant="rounded" width="100%" height={400} />
                        :
                        <ChartComponent id={`${tab}-demandaxcapacidade`} style={{ textAlign: "center" }} legendSettings={{ enableHighlight: true }}
                            primaryXAxis={primaryxAxis} primaryYAxis={primaryyAxis} axisLabelRender={axisLabelRender} chartArea={{ border: { width: 0 } }} tooltip={{ enable: true, header: "<b>${point.tooltip}</b>", shared: true }} width="1200" title='' pointRender={onPointRender} center={{ x: '50%' }}>
                            <Inject services={[BarSeries, Legend, Tooltip, Category, DataLabel, Highlight]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective
                                    cornerRadius={{ bottomRight: 5, topRight: 5 }}
                                    dataSource={DemandaXCapacidade.sort((a, b) => a.y - b.y)}
                                    tooltipMappingName='toolTipMappingName'
                                    xName='x'
                                    yName='y'
                                    type='Bar'
                                    marker={{
                                        dataLabel: {
                                            font: {
                                                size: '16px',
                                                fontWeight: '500'
                                            },
                                            visible: true,
                                            position: "Top",
                                            template: (point) => {
                                                return `${point.point.y}`;
                                            },
                                        },
                                    }}
                                />
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    }
                </div>
            </div>
        </>
    )
}